module.exports = __webpack_public_path__ + "static/img/report_active.7b18140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdSimulator/report_active.png
// module id = oWVG
// module chunks = 1